import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSize(1.2)};
  min-width: 65vw;
  align-items: center;
`;

export const Header = styled.p`
  align-self: flex-start;
  margin: 0;
  font-size: ${getSize(1.9)};
  font-weight: 600;
`;

export const Videos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSize(2.4)};
  width: 100%;

  ${responsive("laptop")} {
    flex-direction: row;
  }
`;

export const PlayerBox = styled.div`
  flex: 1;
  min-width: 0;
`;

// Caps the list at the player's height (280px) so it scrolls beside it.
export const ListBox = styled.div`
  flex: 1;
  display: flex;
  max-height: 280px;
`;

export const MoreHelpText = styled.h3`
  color: ${getColor("text")};
  font-weight: 500;
  font-size: ${getSize(1.6)};
`;

export const MoreHelpLink = styled.a`
  color: ${getColor("primary")};
  text-decoration: underline;
  text-decoration-color: ${getColor("primary")};
  font-weight: 500;
  font-size: ${getSize(1.6)};
`;
